import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { newM1Data as newM1DataIN } from './IN';
import { newM1Data as newM1DataAE } from './AE';
import { M1_Switzerland, M1_Iceland, M1_Euro, NON_MCF_M1_Euro } from './EU';
import { newM1Data as newM1DataGB } from './GB';
import { newM1Data as newM1DataUS } from './US';
import { isMCFCountry } from 'lib/region/countryUtils';

export const M1Data = {
  [ShopifyStore.IN]: newM1DataIN,
  [ShopifyStore.AE]: newM1DataAE,
  [ShopifyStore.GB]: newM1DataGB,
  [ShopifyStore.US]: newM1DataUS,
  [ShopifyStore.EU]: M1_Euro,
};

// The EU store fans out per country; every other store is a direct lookup.
export function getM1DataForStore(store: ShopifyStore, countryCode?: string) {
  if (store !== ShopifyStore.EU) {
    return M1Data[store as keyof typeof M1Data] || {};
  }

  if (!countryCode) return M1_Euro;

  switch (countryCode.toLowerCase()) {
    case 'ch':
      return M1_Switzerland;
    case 'is':
      return M1_Iceland;
    default:
      return isMCFCountry(countryCode) ? M1_Euro : NON_MCF_M1_Euro;
  }
}
